import UserList from "../components/UserList";
import Navbar from "../components/Navbar";
import TaskList from "../components/TaskList";
import NewAutocomplete from "../components/NewAutcomplete";
import { useEffect, useState } from "react";
import { fetchUsers } from "../api";
import UserImage from "../components/UserImage";
import AutoLinkText from "../components/TextComponents/AutoLinkText";
import TestComponent from "../components/TestComponent";

const Test = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers().then(setUsers);
  }, []);

  return (
    <>
      <div style={{ padding: "5rem" }}>
        <AutoLinkText text="youtube.com" />
        <NewAutocomplete
          options={users}
          optionLabel={(option) => {
            return option.first_name + " " + option.last_name;
          }}
          optionDisplay={(option) => {
            return (
              <div style={{ display: "flex", alignItems: "center" }}>
                <UserImage targetUser={option} />
                {option.first_name + " " + option.last_name}
              </div>
            );
          }}
        />
      </div>
      <TestComponent />
    </>
  );
};

export default Test;
